<template>
  <div class="item-actionsv2">
    <div class="share-item-section square">
      <div class="d-none d-md-block">
        <div class="title">
          {{ shareCopy }}
        </div>
        <div class="share-url d-flex align-items-center">
          <copy-to-clipboard :label="item.links.share_url.replace(/(^\w+:|^)\/\//, '')" :value="item.links.share_url">Link copied</copy-to-clipboard>
        </div>
      </div>
      <div class="copy-to-clipboard-wrapper">
        <a href="#" title="Share Drop" id="shareDropModal" data-testid="shareDropModal" data-dismiss="modal" data-toggle="modal" @click="track('open_share_item_modal')" data-target="#shareModal" class="copy-to-clipboard cloudapp-btn blue">
          <i class="fas fa-paper-plane"></i>
          Share
        </a>
        <div v-if="isOwner" id="one-time-tooltip" class="one-time-tooltip">
          <div>
            <div class="one-time-tooltip-header">
              Congrats, you made your first {{ item.attributes.item_type || 'item' }} 🎉
              <span id="close-one-time-tooltip"> <i class="fas fa-times-circle tooltip-close"></i> </span>
            </div>
            <div class="one-time-tooltip-text">
              A unique link is always created and copied to your clipboard instantly. Now share it!
              <br>
              <a :href="onboardingVideoUrl" class="font-color-bright-blue font-size-10" target="_blank" data-testid="learn-more-about-cloudapp-viewer">
                Learn more
              </a>
            </div>
          </div>
          <div class="arrow-right"></div>
        </div>
      </div>
    </div>
    <!-- only show security settings if you're the owner -->
    <template v-if="isOwner && currentOrganization.attributes.is_paying">
      <div v-if="!$root.customDomainOrigin" class="d-none d-md-block">
        <div id="share-settings-preview" class="share-security">
          <span class="item-setting-label">{{itemSecurityLabel}}</span>
          <a data-toggle="modal" class="edit-settings" :data-target='`#security-settings-modal-${item.id}`' data-testid="sharesettings" title="Security Settings" href="#">
            Edit
          </a>
        </div>
        <div id="expire-settings-preview" class="share-security" v-show="item.attributes.security.expires != 'ne'">
          <span class="item-setting-label" :class="{warning: item.attributes.security.expires != 'ne'}">{{itemExpirationLabel}}</span>
          <a data-toggle="modal" class="edit-settings" :data-target='`#security-settings-modal-${item.id}`' data-testid="sharesettings" title="Security Settings" href="#">
            Edit
          </a>
        </div>
      </div>
    </template>
    <!-- show save to my cloudapp button only is not owner and if hide_cloudapp_branding is turned off and user is not view only -->
    <template v-else-if="!itemOrganization.attributes.preferences.hide_cloudapp_branding && !viewOnlyUser">
      <div class="bottom-section square save-drop" :class="{ instantVideo: isInstantVideo }">
        <template v-if="$root.userLoggedIn">
          <a
            v-if="!viewOnlyUser && showCopyDrop"
            title="Copy Drop"
            data-testid="footer-actions-copy"
            :href="isInstantVideo ? '' : $root.routes.copy_item_url(item.id || '')"
          >
            <span class="action-label">Save to my CloudApp</span>
            <span class="processing-label">Processing</span>
          </a>
        </template>
        <template v-else>
          <a
            v-if="$root.customDomainOrigin"
            :href="isInstantVideo ? '' : $root.routes.login_url({ host: gon.baseWebDomain, return_to: $root.routes.copy_item_url({ host: gon.baseWebDomain, id: item.id }) })">
              <span class="action-label">Save to my CloudApp</span>
              <span class="processing-label">Processing</span>
          </a>
          <a v-else-if="showCopyDrop" href="#" v-b-modal.signup-modal title="Save Drop" data-testid="footer-actions-copy" @click="setUtmParams">
            <span class="action-label">Save to my CloudApp</span>
            <span class="processing-label">Processing</span>
          </a>
        </template>
      </div>
    </template>

    <!-- we show this to viewonlyuser too, because we show a request licencse modal if they click one of these options -->
    <div class="actions-section" v-if="isOwner || viewOnlyUser">
      <div class="add-button">
        <a :href="viewOnlyUser ? '#view-only' : '#'" title="Add Button" id="toggle-cta" data-testid="cta-menu-link" v-b-toggle.cta-sidebar>
          <img v-if="showProRibbon" src="@img/pro-ribbon.png" class="img-pro-ribbon" data-testid="img-pro-ribbon" />
          <i class="fas fa-mouse-click align-text-top" data-toggle="tooltip" data-placement="top" title="Add button"></i>
          <span class="owner-action-label">Add Button</span>
        </a>
      </div>
      <template v-if="templatesEnabled">
        <div class="apply-template">
          <template-upgrade-modal/>
          <trial-offer-modal nodefaults @decline="$bvModal.hide('trial-offer-modal')" @accept="acceptTrialOffer()"/><trial-used-modal/>
          <pro-link :showProRibbon="showProRibbon" id="template" title="Apply template" @pro-click="$bvModal.show('template-modal')" @free-click="$bvModal.show('template-upgrade-modal')" icon="fas fa-magic">
            Apply template
          </pro-link>
          <div class="popover-template" v-if="gon.show_viewer_templates_coachmark">
            <popover
              id="popover-target-template"
              heading="New! Templates"
              content="Enhance your content and speed up your workflow!"
              placement="right"
              image="comments"
              event="viewer_coachmark_viewed"
              :delay="0"
              :eventParams="{ feature: 'templates' }"
            >
            </popover>
          </div>
        </div>
      </template>
    </div>
    <div class="actions-section">
      <template v-if="isOwner || viewOnlyUser">
        <div v-if="!item.uploading && allowWebAnnotation" class="d-none d-md-block">
          <router-link
            data-testid="viewer-annotate-link"
            :to="webAnnotateRoute">
            <i class="icon-annotate align-text-top"></i>
            <p class="owner-action-label">Annotate</p>
          </router-link>
        </div>
        <div v-else-if="gon.showAnnotateInClient && !item.attributes.uploading && annotable" class="d-none d-md-block">
          <a :href="annotateInClientUrl" @click="trackClientAnnotate" data-testid="viewer-annotate-link">
            <i class="icon-video-trim align-text-top"></i>
            <span class="owner-action-label">
              Annotate
            </span>
          </a>
        </div>
      </template>
      <template v-if="isOwner || itemOrganization.attributes.preferences.download_button != false">
        <div class="download-action">
          <template v-if="itemProcessing">
            <a class="disabled">
              <i class="fa fa-download align-text-top" data-toggle="tooltip" data-placement="top" title="Download not yet available"></i>
              <p class="owner-action-label">
                <span class="hover-visible">(Processing ...)</span>
                <span class="hover-hidden">Download</span>
              </p>
            </a>
          </template>
          <template v-else>
            <a v-if="downloadInterstitialEnabled" data-testid="footer-actions-download" title="Download Drop" @click="$bvModal.show('download-modal')" href="#">
              <i class="fa fa-download align-text-top" data-toggle="tooltip" data-placement="top" title="Download"></i>
              <span class="owner-action-label">Download</span>
            </a>
            <a v-else data-testid="footer-actions-download" title="Download Drop" :href="$root.routes.viewer_download_item_url({ slug: item.id, filename: item.attributes.name, utm_source: 'viewer' })">
              <i class="fa fa-download align-text-top" data-toggle="tooltip" data-placement="top" title="Download"></i>
              <span class="owner-action-label">Download</span>
            </a>
          </template>
        </div>
      </template>
      <b-dropdown
        v-if="isOwner || viewOnlyUser"
        toggle-class="toggle-secondary-actions"
        menu-class="secondary-actions"
        no-caret
        right
        id="more-actions"
        title="show more">
        <template #button-content>
          <i class="fas fa-ellipsis-h"></i>
          <span class="owner-action-label">More</span>
        </template>
        <b-dropdown-form id="toggle-comments-form" v-if="!itemOrganization.attributes.preferences.comments_disabled && !viewOnlyUser">
          <span>
            Allow comments
          </span>
          <b-form-checkbox id="toggle-comments" data-testid="disable-commenting" v-model="commentsEnabled" name="check-button" switch />
        </b-dropdown-form>
        <b-dropdown-item href="#" ref="copyDirectLink" :disabled="itemProcessing" :data-clipboard-text="item.links.content_url" data-testid="copy-direct-link-to-clipboard" :class="itemProcessing ? 'text-muted' : ''">
          {{ copyLinkMsg }}
        </b-dropdown-item>
        <b-dropdown-item
          id="add-to-collection"
          title="Add To Collection"
          data-testid="footer-actions-add-to-collection"
          :data-remote="!viewOnlyUser"
          :href="addToCollectionURL">
          Add to collection
        </b-dropdown-item>
        <b-dropdown-item v-if="!$root.customDomainOrigin" :href="customizeLink" title="Customize" data-testid="footer-actions-customize">
          Customize page
          <pro-badge :visible="showProRibbon" :trial="currentOrganization.attributes.trial" :learnmore_url="$root.routes.customize_settings_organization_path(currentOrganization.id || '')" utm_source="viewer" utm_campaign="upgrade" utm_medium="customize"></pro-badge>
        </b-dropdown-item>
        <b-dropdown-item variant="danger" @click="archiveItem" v-if="!viewOnlyUser">Archive</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import CopyToClipboard from '@cmp/copy_to_clipboard.vue';
import ProBadge from '@cmp/pro_badge.vue';
import ProLink from '@cmp/viewer/pro_link.vue';
import TemplateUpgradeModal from '@cmp/viewer/template_upgrade_modal.vue';
import TrialOfferModal from  '@cmp/shared/trial_offer_modal.vue';
import TrialUsedModal from  '@cmp/shared/trial_used_modal.vue';
import Popover from '@cmp/popover.vue'

import { DateTime } from "luxon";
import { mapState } from 'vuex';
import featureKey from '../../feature_key.macro';
import track from '@/src/tracking';


export default {
  components: { TemplateUpgradeModal, TrialOfferModal, TrialUsedModal, CopyToClipboard, ProBadge, ProLink, Popover },
  props: {
    isOwner: { required: true, type: Boolean }
  },
  data: function(){
    return {
      onboardingVideoUrl: ''
    }
  },
  created: function(){
    const vm = this;
    vm.$store.dispatch('getConfiguration', 'viewer_onboarding_video').then((response) => vm.onboardingVideoUrl = response.data.data.dropper_configuration?.attributes?.content)
  },
  mounted: function(){
    const vm = this;
    if (vm.$refs.copyDirectLink) {
      const clipboard = new ClipboardJS(vm.$refs.copyDirectLink.$el.children[0]);
      clipboard.on('success', () => vm.$root.toastSuccess('Direct link copied to clipboard.'));
      clipboard.on('error', () => vm.$root.toastError('Could not copy link, try again later.'));
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user,
      item: state => state.item,
      itemOrganization: state => state.itemOrganization,
      currentOrganization: state => state.currentOrganization,
      features: state => state.features,
      viewOnlyUser: state => state.itemOrganization.attributes.current_user_view_only,
    }),
    addToCollectionURL: function(){
      if(this.viewOnlyUser){
        return "#view-only";
      }else{
        return this.$root.routes.collections_organization_url(this.currentOrganization.id || '', { item_id: this.item.id });
      }
    },
    annotable: function () {
      if (this.item.attributes.item_type != "video" && this.item.attributes.item_type != "image") {
        return false;
      }
      return true;
    },
    annotateInClientUrl: function(){
      const link = "cloudapp://annotate/" + this.item.id;

      if(this.$root.userLoggedIn){
        return link + "?jwt=" + this.currentUser.attributes.jwt_token;
      }

      return link;
    },
    allowWebAnnotation: function () {
      if (this.item.attributes.item_type !== "image") {
        return false;
      }
      if (this.item.attributes.file_ext == ".gif") {
        return false;
      }
      return true;
    },
    commentsEnabled: {
      get: function(){ return !this.item.attributes.comments_disabled; },
      set: function(value){
        this.$store.dispatch('updateItem', { itemId: this.item.id, body: { comments_disabled: !value } })
      },
    },
    copyLinkMsg: function() {
      return this.itemProcessing ? "Copy direct link (processing)" : "Copy direct link";
    },
    hideCopyDrop: function(){
      return this.isOwner || (this.currentOrganization.id != this.itemOrganization.id && this.inCustomStorage);
    },
    inCustomStorage: function(){
      return !!(this.item.attributes.in_custom_storage || this.currentOrganization.attributes.custom_storage);
    },
    itemSecurityLabel: function(){
      const settings = {
        un: 'Anyone with the link can view',
        og: 'Anyone can view in your organization',
        oe: 'Anyone can edit in your organization',
        pw: 'Anyone with the passcode can view',
        em: 'Anyone providing email can view',
        su: 'Only specific users can view',
        se: 'Only specific users can edit'
      };
      return settings[this.item.attributes.security.sharing];
    },
    itemProcessing: function() {
      return this.item.attributes.uploading || this.item.attributes.instant_video;
    },
    itemExpirationLabel: function(){
      const expires = this.item.attributes.security.expires;
      if(expires == 'ne') {
        return 'Never expires';
      }

      let labels = [];
      const expiresAfterViews = this.item.attributes.security.expires_after_views;
      if(expiresAfterViews && expiresAfterViews != ""){
        labels.push(`after ${expiresAfterViews} views`)
      }

      const expiresAt = this.item.attributes.security.expires_at;
      if(expiresAt && expiresAt != ""){
        const date = DateTime.fromISO(expiresAt);
        const today = DateTime.local();
        const diff = date.diff(today, ['days']);
        labels.push(`in ${Math.ceil(diff.days)} days`)
      }

      return `Expires ${labels.join(' or ')}`;
    },
    showCopyDrop: function(){
      return !this.hideCopyDrop && (this.item.attributes.media || (this.$root.userLoggedIn && !this.currentUser.attributes.is_free))
    },
    shareCopy: function(){
      const itemType = this.isInstantVideo ? "video" : this.item.attributes.item_type;
      return itemType ? `Share ${this.isOwner ? "your" : "this" } ${itemType}` : 'Share';
    },
    isInstantVideo: function(){
      return this.item.attributes.m3u8 || this.item.attributes.instant_video;
    },
    templatesEnabled: function(){
      const isFeatureOn = this.features?.[featureKey("web-experiment-viewer_templates_feature")];
      return isFeatureOn && this.isOwner && !this.viewOnlyUser;
    },
    webAnnotateRoute: function(){
      if(this.viewOnlyUser){
        return { path: this.$route.path, hash: 'view-only'}
      }else{
        return { name: 'annotate', params: { slug: this.item.id } }
      }
    },
    showProRibbon: function() {
      return !this.features?.[featureKey("upgrade-button-dashboard-viewer")] && this.currentOrganization.attributes.free;
    },
    customizeLink: function() {
      return !this.features?.[featureKey("upgrade-button-dashboard-viewer")] && this.currentOrganization.attributes.free ?
        "#prompt-branding" :
        this.$root.routes.customize_settings_organization_path(this.currentOrganization.id || '');
    },
    downloadInterstitialEnabled: function(){
      return this.features?.[featureKey("web-experiment-show-download-interstitial")];
    }
  },
  methods: {
    archiveItem: function(){
      const vm = this;
      vm.$store.dispatch('destroyItem', vm.item.id)
        .then((response) => {
          vm.$root.toastSuccess(response.data.message)
          window.location = '/dashboard';
        })
        .catch(() => vm.$root.toastError('Could not archive item, please try again.'))
    },
    acceptTrialOffer: function() {
      const vm = this;
      vm.$bvModal.hide("trial-offer-modal");
      vm.$store.dispatch("reloadCurrentOrganization").then(function() {
        if (vm.$store.state.currentOrganization.attributes.free == false) {
          vm.$root.toastSuccess("Welcome to CloudApp Pro!");
          vm.$bvModal.show("template-modal");
        }
      });
    },
    openDownloadModal: function(){
      $('#downloadModal').modal();
    },
    openCTAEditor: function(e){
      if(this.viewOnlyUser) {
        this.$router.push({ path: this.$route.path, hash: "view-only" })
      }else {
        this.$root.cta.menuOpen = true
      }
    },
    setUtmParams: function(){
      const vm = this;
      setTimeout(function(){
        // these are globally defined functions in the asset pipeline, that make use of HTML5 history to emulate $router
        // we should move them to vue or find a better way to do this in vue components.
        setModalUTM(viewerUtmParams('save_footer_link', null, 'viewer_new'));
        addURLParams({'post_onboarding': JSON.stringify({ 'action': 'copy', 'arguments': { 'item_id': vm.item.id }})});
      }, 200)
    },
    track: track,
    trackClientAnnotate: function(){
      let platform = navigator.platform;
      if(platform.match(/win/i)){
        platform = "windows";
      } else if(platform.match(/mac/i)) {
        platform = "mac";
      } else {
        platform = "chrome";
      }
      track('web_annotate_clicked', { platform });
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/application.scss';
  .actions-section {
    display: flex;

    .owner-action-label {
      font-size: 0.75rem;
    }

    > div {
      flex: 1;
      text-align: center;
      color: $dark-gray;
      box-shadow: none;
      background-color: #fff;
      border-right: 1px solid #cecece;
      height: 52px;

      a {
        color: $dark-gray;
        display: flex;
        flex-direction: column;
        padding: 10px;

        i {
          height: 15px;
          font-size: 15px;
        }

        .fa-mouse-click { content: url('@img/add-cta.svg') }
        .icon-annotate { content: url('@img/annotate.svg') }
        .icon-video-trim { content: url('@img/video-trim.svg') }

        &:hover {
          text-decoration: none;
          color: $bright-blue;

          .fa-mouse-click { content: url('@img/add-cta-active.svg') }
          .icon-annotate { content: url('@img/annotate-active.svg') }
          .icon-video-trim { content: url('@img/video-trim-active.svg') }
        }
      }

      &:only-child {
        border-radius: 4px !important;
      }

      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-right: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  .img-pro-ribbon {
    width: 40px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .download-action {
    &:hover {
      .hover-visible {
        display: block;
        cursor: not-allowed;
      }

      .hover-hidden {
        display: none;
      }
    }

    .hover-visible {
      display: none;
    }
  }

  .save-drop {
    .processing-label { display: none; }

    &.instantVideo:hover {
      cursor: progress;

      a { pointer-events: none; }

      .processing-label {
        color: $bright-blue;
        display: inline-block;
      }

      .action-label { display: none; }
    }
  }

  #add-cta {
    cursor: pointer;
  }

  .share-security {
    background: white;
    border-radius: 4px;
    box-shadow: 0 14px 30px 0 rgba(0, 0, 0, .15);
    padding: 1rem;
    font-size: 0.75rem;
    text-align: center;
    margin: 1px 0;
    display: flex;
    justify-content: space-between;

    .item-setting-label {
      text-align: left;

      &.warning {
        color: $sunset-orange;
      }
    }
  }

  #more-actions {
    display: flex;

    > a {
      width: 100%;
      height: 100%;
      font-size: 1rem;
      line-height: 44px;
    }
  }

  #toggle-comments-form {
    padding: .25rem 0.5rem;
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .custom-switch {
      margin-right: -4px;
    }
  }

  /deep/ #more-actions {
    > button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &:only-child > button {
      border-radius: 4px;
    }
  }

  /deep/ .secondary-actions {
    border-radius: 10px;

    li {
      > a {
        display: flex !important;
        justify-content: space-between;
        align-items: center;
        padding: .25rem 0.5rem;
      }
    }
  }

  /deep/ .toggle-secondary-actions {
    background: white !important;
    border: none;
    color: #4a4a4a !important;
    box-shadow: none !important;

    &:hover, &:active {
      color: #007AFF !important;
      outline: none;
    }
  }

  @media (max-width: 767px){
    .item-actionsv2 {
      .share-item-section {
        padding: unset;
        margin: 0.5rem 0 !important;
      }

      .bottom-section {
        margin: 0.5rem;
      }

      .save-drop {
        margin: 0 0.5rem 1rem !important;
      }

      .actions-section {
        box-shadow: unset !important;

        > div {
          border-right: 0;
          border-radius: 4px !important;
        }

        > a {
          height: 3.4rem;
          margin: 0rem 0.5rem 1rem 0.5rem;
          border: unset !important;
          border-radius: 4px;
          box-shadow: 0 14px 30px 0 rgba(0, 0, 0, .15) !important;
        }
      }
    }

    .save-drop, .apply-template, .add-button, #more-actions {
      display: none;
    }
  }
</style>
